// Sidebar sections + expense categories metadata
import { FEATURES } from '@/lib/featureFlags';

// Entries with a `flag` are hidden until the matching feature flag is on.
const SECTIONS_ALL = [
  { id: 'prehlad',    path: '/',           label: 'Prehľad',     color: 'blue',   icon: 'gauge'  },
  { id: 'faktury',    path: '/faktury',    label: 'Faktúry',     color: 'green',  icon: 'doc'    },
  { id: 'cenove-ponuky', path: '/cenove-ponuky', label: 'Cenové ponuky', color: 'blue', icon: 'euro' },
  { id: 'vydavky',    path: '/vydavky',    label: 'Výdavky',     color: 'red',    icon: 'receipt'},
  { id: 'polozky',    path: '/polozky',    label: 'Položky',     color: 'yellow', icon: 'box' },
  { id: 'dokumenty',  path: '/dokumenty',  label: 'Dokumenty',   color: 'blue',   icon: 'folder', flag: 'documents' },
  { id: 'klienti',    path: '/klienti',    label: 'Klienti',     color: 'yellow', icon: 'users'  },
  { id: 'reporting',  path: '/reporting',  label: 'Reporting',   color: 'blue',   icon: 'archive'},
  { id: 'nastavenia', path: '/nastavenia', label: 'Nastavenia',  color: 'gray',   icon: 'gear'   },
];

export const SECTIONS = SECTIONS_ALL.filter(s => !s.flag || FEATURES[s.flag]);

// F-007 Document Hub — typy dokumentov (musí sediet s CHECK constraintom v
// supabase/migrations/2026-05-12-document-hub-spike.sql)
export const DOC_TYPES = {
  zmluva:               { label: 'Zmluva',              color: 'blue',   icon: 'doc'     },
  danove_priznanie:     { label: 'Daňové priznanie',    color: 'red',    icon: 'percent' },
  bankovy_vypis:        { label: 'Bankový výpis',       color: 'green',  icon: 'bank'    },
  dodavatelska_faktura: { label: 'Dodávateľská faktúra',color: 'yellow', icon: 'receipt' },
  uradny_dokument:      { label: 'Úradný dokument',     color: 'red',    icon: 'alert'   },
  iny:                  { label: 'Iný',                 color: 'gray',   icon: 'other'   },
};

export const DOC_TYPE_KEYS = Object.keys(DOC_TYPES);

export const CATEGORIES = {
  food:      { label: 'Strava',        color: 'red',    icon: 'food'     },
  fuel:      { label: 'Pohonné hmoty', color: 'yellow', icon: 'fuel'     },
  software:  { label: 'Softvér',       color: 'blue',   icon: 'software' },
  hardware:  { label: 'Hardvér',       color: 'gray',   icon: 'hardware' },
  marketing: { label: 'Marketing',     color: 'red',    icon: 'marketing'},
  office:    { label: 'Kancelária',    color: 'yellow', icon: 'office'   },
  services:  { label: 'Služby',        color: 'green',  icon: 'services' },
  other:     { label: 'Ostatné',       color: 'gray',   icon: 'other'    },
};

export const CATEGORY_KEYS = Object.keys(CATEGORIES);

export const STATUS_LABELS = {
  draft:     'Koncept',
  issued:    'Vystavená',
  paid:      'Zaplatená',
  overdue:   'Po splatnosti',
  cancelled: 'Zrušená',
};

export const DPH_RATES = [0, 10, 20, 23];
